import { observable, computed } from 'mobx';
import { SHARE_METHOD_CONFIG } from '@src/business-components/top-menu/config';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { useEffect } from 'react';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import copy from '../../../../components/copy';
import { aLink } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
const lang = getLanguageByPath();
const pageLocalesData = getPageLocalesData();
const mainLocalesData = pageLocalesData.main;

class contactWayPageStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 是否激活
  @observable isActive = false;
  // page7数据
  @observable
  customerServiceData = {
    en: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/en-US/index',
    ja: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ja-JP/index',
    ko: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ko-KR/index',
    'zh-Hant': 'https://gm-mobile.amazingseasun.com/app/h5/jxj/zh-TW/index',
    tc: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/zh-TW/index',
    es: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/es-ES/index',
    pt: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/pt-PT/index',
    de: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/de-DE/index',
    fr: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/fr-FR/index',
    ru: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ru-RU/index',
    th: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/th-TH/index'
  };

  gotoCustomer(lang) {
    window.open(this.customerServiceData[lang], '_blank');
  }
  copyEmail = () => {
    copy('press@seasungames.com', { successPreText: `${pageLocalesData.global.copy_success_tips_text}` });
  };
  /**
   * 点击跳转
   * @param url
   */
  @autobind
  onRedirectLink(url) {
    if (url) {
      aLink(url);
    }
  }
  onClick() { }

  @computed
  get itemList() {
    return SHARE_METHOD_CONFIG.filter(item => item.applyLanguages.includes(lang))
      .sort((a, b) => a.order[lang] - b.order[lang])
      .map(item => ({
        name: item.name,
        link: item.linkLocales[lang],
        img: item.img,
        onClick: this.onClick()
      }));
  }

  use() {
    useEffect(() => { }, []);
  }
}

export default contactWayPageStore;
